'use strict';

import { BaseElement } from '../../interfaces/BaseElement';
import { Switch } from '../../interfaces/switchers/Switch';
import { changeLangToCurrent } from '../langSwitcher/langSwitcher';
import gsap from 'gsap';
import {projectMode, settingsData, threeJsVariables} from '../../../settings';
import { Box3, Vector3 } from 'three';
import {updateShadowMap} from "../../threejs/lights";

export class FutureDevelopment {
    #vec3 = new Vector3();
    #box3 = new Box3();

    constructor (parent) {
        this.settings = config.features.futureDevelopment || {active: false, checked: false, list: []};
        this.active = (this.settings.active && this.settings.list.length && !projectMode.LiteMode.isActive() && !projectMode.AirMode.active);
        if (!this.active) return;

        this.parent = parent;
        this.blockAnimation = false;
    }

    createSwitcher() {
        if (!this.active) return;

        this.mainContainer = new BaseElement()
            .addClass('future-development','display-option','display-options__future-development')
            .appendTo(this.parent)
            .DOMElement;

        new BaseElement('span')
            .addClass('future-development__title','language-string')
            .addAttribute('data-dictionary','Future development')
            .innerHtml(changeLangToCurrent('Future development'))
            .appendTo(this.mainContainer);

        this.switcher = new Switch(this.mainContainer);
        this.switcher.checked = this.settings.checked;
        this.switcherState = this.settings.checked;
        this.switcher.listener = this.switcherHandler.bind(this);
        this.settings.list.forEach(name => {
            const objectOnScene = threeJsVariables.scene.getObjectByName(name);
            if (objectOnScene) {
                this.#box3.setFromObject(objectOnScene).getSize(this.#vec3);
                objectOnScene.userData.y = objectOnScene.position.y;
                objectOnScene.userData.size = this.#vec3.y;
            }
        });

        if (!this.settings.checked) {
            const event = new Event('change');
            this.switcher.checkbox.dispatchEvent(event);
        } else {
            this.settings.list.forEach(name => {
                const objectOnScene = threeJsVariables.scene.getObjectByName(name);
                if (objectOnScene)
                    objectOnScene.position.y = this.switcherState ? objectOnScene.userData.y : objectOnScene.userData.y - objectOnScene.userData.size;
            });
        }
    }

    switcherHandler(e) {
        if (this.blockAnimation) {
            this.switcher.checkbox.checked = this.switcherState;
            return;
        }

       this.switcherState = e.target.checked;
        const tl = gsap.timeline({
            paused: true,
            onStart: () => this.blockAnimation = true,
            onUpdate: () => updateShadowMap(),
            onComplete: () => this.blockAnimation = false
        });

        this.settings.list.forEach(name => {
           const objectOnScene = threeJsVariables.scene.getObjectByName(name);
           if (objectOnScene) {
               const animation = gsap.to(objectOnScene.position,{
                   y: this.switcherState ? objectOnScene.userData.y : objectOnScene.userData.y - objectOnScene.userData.size,
                   duration: 1,
                   onStart: () => {
                       if (this.switcherState) {
                           objectOnScene.visible = true;
                       }
                   },
                   onComplete: () => {
                       if (!this.switcherState) {
                           objectOnScene.visible = false
                       }
                   }
               });

               tl.add(animation,0);
           }
        });
        tl.play(0);
    }

}
